import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { StoreModule } from '@ngrx/store';
//import { StoreLogMonitorModule, useLogMonitor } from '@ngrx/store-log-monitor';
//import { StoreDevtoolsModule } from '@ngrx/store-devtools';
//import { ServiceWorkerModule } from '@angular/service-worker';
//import { RouteReuseStrategy } from "@angular/router";
import { CookieService } from 'angular2-cookie/core';
import { AppComponent } from './app.component';
import { routing } from './app.routing';
import { LoginService } from './login/login.service';
import { UmrCookieService } from './common/services/umr-cookie.service';
import { AuthService } from './common/auth.service';
import { AuthGuard } from './auth.guard';
import { MainResolver } from './main/main.resolver';
import { UserInformationService } from './common/services/user-information.service';
import { LastRecordAccessService } from './common/services/last-record-access.service';
import { MainComponent } from './main/main.component';
import { LoginComponent } from './login/login.component';
import { LoadingImageModule } from './common/loading-image.module';
import { reducers } from './stores/index-store';
import { SharedModule } from './common/shared.module';
import { PrimeSharedModule } from './common/primeshared.module';
import { TokenInterceptorService } from './common/token-interceptor.service';
//import { CustomReuseStrategy } from "./app.route-reuse-strategy";
import { CustomPreloading } from './app.custom-preloading';

export function cookieServiceFactory() {
    return new CookieService();
}
@NgModule({
    imports: [
        SharedModule,
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        HttpModule,
        HttpClientModule,
        routing,
        LoadingImageModule,
        PrimeSharedModule,
        StoreModule.forRoot(reducers)
        //, StoreLogMonitorModule,
        //StoreDevtoolsModule.instrumentStore({
        //    monitor: useLogMonitor({
        //        visible: true,
        //        position: 'right',
        //        size: 0.20
        //    })
        //})
        //, ServiceWorkerModule.register('/UMRPortalsSPA/ngsw-worker.js', { enabled: true })
    ],
    declarations: [AppComponent, MainComponent, LoginComponent],
    providers: [{ provide: CookieService, useFactory: cookieServiceFactory },
    {
        provide: HTTP_INTERCEPTORS,
        useClass: TokenInterceptorService,
        multi: true
    },
        //{ provide: RouteReuseStrategy, useClass: CustomReuseStrategy },
        CustomPreloading,
        LoginService, UmrCookieService, AuthService, AuthGuard, MainResolver, UserInformationService, LastRecordAccessService],
    bootstrap: [AppComponent]
})
export class AppModule { }
